export const SERVICE_CODE = 'EXPENSE' + '_SERVICE';
